// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2brzn","amount":"Amount_amount__1FJyD","tip":"Amount_tip__2BFph","tipHeader":"Amount_tipHeader__3Vgnk","tipsWrap":"Amount_tipsWrap__pbrA_"};